var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "stars-rate",
      class: {
        "stars-rate--color-red": _vm.color === "red",
        "stars-rate--color-grey": _vm.color === "grey",
        "stars-rate--color-yellow": !_vm.color,
        "stars-rate--size-sm": _vm.size === "sm",
        "stars-rate--size-lg": _vm.size === "lg",
      },
      attrs: { "data-qa": "stars_rate" },
    },
    [
      _c("div", {
        staticClass: "stars-rate__progress",
        style: {
          width: `${_setup.filterStarsProgress(_vm.solidity)}em`,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }